var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMigration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 56 56",
    width: 56,
    height: 56,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M49 19C49 12.92 44.08 8 38 8C36.22 8 34.55 8.43 33.07 9.18C31.15 4.39 26.48 1 21 1C13.82 1 8 6.82 8 14C8 15.79 8.36 17.5 9.02 19.06C4.51 19.55 1 23.36 1 28C1 32.97 5.03 37 10 37C11.7 37 13.28 36.52 14.64 35.7C15.08 35.85 15.54 35.97 16 36.09C16 35.99 16 35.15 16 35.05C15.65 34.95 15.29 34.86 14.96 34.75C14.93 34.74 14.78 34.69 14.52 34.61C14.28 34.75 14.15 34.83 14.12 34.84C12.87 35.6 11.44 36 10 36C5.59 36 2 32.41 2 28C2 23.91 5.06 20.49 9.13 20.05C9.22 20.04 9.66 19.99 10.46 19.9C10.15 19.16 9.98 18.75 9.94 18.67C9.32 17.19 9 15.62 9 14C9 7.38 14.38 2 21 2C25.93 2 30.3 4.96 32.14 9.55C32.16 9.62 32.3 9.96 32.54 10.56C33.13 10.27 33.45 10.11 33.52 10.07C34.93 9.36 36.44 9 38 9C43.51 9 48 13.49 48 19C48 20.24 47.77 21.47 47.3 22.65C47.27 22.73 47.1 23.17 46.79 23.96C47.63 23.99 48.11 24.01 48.2 24.01C51.45 24.12 54 26.75 54 30C54 33.31 51.31 36 48 36C46.86 36 45.75 35.67 44.78 35.06C44.76 35.04 44.61 34.95 44.35 34.78C44.06 34.9 43.9 34.96 43.87 34.97C42.75 35.43 41.41 35.73 40 35.88C40 35.98 40 36.79 40 36.89C41.58 36.73 43.03 36.39 44.25 35.9C45.33 36.59 46.62 37 48 37C51.87 37 55 33.87 55 30C55 26.21 51.99 23.14 48.23 23.01C48.72 21.77 49 20.42 49 19Z",
    id: "a7BqP60yzA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 41.29L39 33.79L37 31.79L37 28L36 28L36 32.21L38 34.21L38 41.71L43.25 47L49 47L49 46L43.71 46L39 41.29Z",
    id: "doTCzthfI"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 27.79L17 29.79L17 41.29L12.29 46L7 46L7 47L12.75 47L18 41.71L18 30.21L20 28.21L20 24L19 24L19 27.79Z",
    id: "bdNw2QOrf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 53.5C39 54.33 39.67 55 40.5 55C41.33 55 42 54.33 42 53.5C42 52.67 41.33 52 40.5 52C39.67 52 39 52.67 39 53.5ZM40 53.5C40 53.22 40.22 53 40.5 53C40.78 53 41 53.22 41 53.5C41 53.78 40.78 54 40.5 54C40.22 54 40 53.78 40 53.5Z",
    id: "b1LYKMGFZ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34 53.5C34 54.33 34.67 55 35.5 55C36.33 55 37 54.33 37 53.5C37 52.67 36.33 52 35.5 52C34.67 52 34 52.67 34 53.5ZM35 53.5C35 53.22 35.22 53 35.5 53C35.78 53 36 53.22 36 53.5C36 53.78 35.78 54 35.5 54C35.22 54 35 53.78 35 53.5Z",
    id: "bbTVni2tV"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 53.5C14 54.33 14.67 55 15.5 55C16.33 55 17 54.33 17 53.5C17 52.67 16.33 52 15.5 52C14.67 52 14 52.67 14 53.5ZM15 53.5C15 53.22 15.22 53 15.5 53C15.78 53 16 53.22 16 53.5C16 53.78 15.78 54 15.5 54C15.22 54 15 53.78 15 53.5Z",
    id: "acbWVzEGK"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 46.5C48 47.33 48.67 48 49.5 48C50.33 48 51 47.33 51 46.5C51 45.67 50.33 45 49.5 45C48.67 45 48 45.67 48 46.5ZM49 46.5C49 46.22 49.22 46 49.5 46C49.78 46 50 46.22 50 46.5C50 46.78 49.78 47 49.5 47C49.22 47 49 46.78 49 46.5Z",
    id: "a6qRBI0fj"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 27.5C35 28.33 35.67 29 36.5 29C37.33 29 38 28.33 38 27.5C38 26.67 37.33 26 36.5 26C35.67 26 35 26.67 35 27.5ZM36 27.5C36 27.22 36.22 27 36.5 27C36.78 27 37 27.22 37 27.5C37 27.78 36.78 28 36.5 28C36.22 28 36 27.78 36 27.5Z",
    id: "a2lHPU0YfD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 53.5C25 54.33 25.67 55 26.5 55C27.33 55 28 54.33 28 53.5C28 52.67 27.33 52 26.5 52C25.67 52 25 52.67 25 53.5ZM26 53.5C26 53.22 26.22 53 26.5 53C26.78 53 27 53.22 27 53.5C27 53.78 26.78 54 26.5 54C26.22 54 26 53.78 26 53.5Z",
    id: "a1AjHK8GIo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29 19.5C29 20.33 29.67 21 30.5 21C31.33 21 32 20.33 32 19.5C32 18.67 31.33 18 30.5 18C29.67 18 29 18.67 29 19.5ZM30 19.5C30 19.22 30.22 19 30.5 19C30.78 19 31 19.22 31 19.5C31 19.78 30.78 20 30.5 20C30.22 20 30 19.78 30 19.5Z",
    id: "d1mvVQgoCA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 46.5C5 47.33 5.67 48 6.5 48C7.33 48 8 47.33 8 46.5C8 45.67 7.33 45 6.5 45C5.67 45 5 45.67 5 46.5ZM6 46.5C6 46.22 6.22 46 6.5 46C6.78 46 7 46.22 7 46.5C7 46.78 6.78 47 6.5 47C6.22 47 6 46.78 6 46.5Z",
    id: "bbz8cWJbTQ"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 53.5C19 54.33 19.67 55 20.5 55C21.33 55 22 54.33 22 53.5C22 52.67 21.33 52 20.5 52C19.67 52 19 52.67 19 53.5ZM20 53.5C20 53.22 20.22 53 20.5 53C20.78 53 21 53.22 21 53.5C21 53.78 20.78 54 20.5 54C20.22 54 20 53.78 20 53.5Z",
    id: "d1abc34VJ2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 32.5C26 33.33 26.67 34 27.5 34C28.33 34 29 33.33 29 32.5C29 31.67 28.33 31 27.5 31C26.67 31 26 31.67 26 32.5ZM27 32.5C27 32.22 27.22 32 27.5 32C27.78 32 28 32.22 28 32.5C28 32.78 27.78 33 27.5 33C27.22 33 27 32.78 27 32.5Z",
    id: "bn2bUpu0d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 22C32.67 22 32 22.67 32 23.5C32 24.33 32.67 25 33.5 25C34.33 25 35 24.33 35 23.5C35 22.67 34.33 22 33.5 22ZM33 23.5C33 23.22 33.22 23 33.5 23C33.78 23 34 23.22 34 23.5C34 23.78 33.78 24 33.5 24C33.22 24 33 23.78 33 23.5Z",
    id: "c35SEsEQo"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19.5C21 20.33 21.67 21 22.5 21C23.33 21 24 20.33 24 19.5C24 18.67 23.33 18 22.5 18C21.67 18 21 18.67 21 19.5ZM22 19.5C22 19.22 22.22 19 22.5 19C22.78 19 23 19.22 23 19.5C23 19.78 22.78 20 22.5 20C22.22 20 22 19.78 22 19.5Z",
    id: "b4GoB4kTu"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5 14C24.67 14 24 14.67 24 15.5C24 16.33 24.67 17 25.5 17C26.33 17 27 16.33 27 15.5C27 14.67 26.33 14 25.5 14ZM25.5 15C25.78 15 26 15.22 26 15.5C26 15.78 25.78 16 25.5 16C25.22 16 25 15.78 25 15.5C25 15.22 25.22 15 25.5 15Z",
    id: "h2FHPqG0qW"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 34.79L34 32.79L34 24L33 24L33 33.21L35 35.21L35 44.72L40 49.22L40 53L41 53L41 48.78L36 44.28L36 34.79Z",
    id: "bgjRsj8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22C18.67 22 18 22.67 18 23.5C18 24.33 18.67 25 19.5 25C20.33 25 21 24.33 21 23.5C21 22.67 20.33 22 19.5 22ZM19.5 23C19.78 23 20 23.22 20 23.5C20 23.78 19.78 24 19.5 24C19.22 24 19 23.78 19 23.5C19 23.22 19.22 23 19.5 23Z",
    id: "fm21aig0n"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 35.79L31 33.79L31 20L30 20L30 34.21L32 36.21L32 46.73L35 49.23L35 53L36 53L36 48.77L33 46.27L33 35.79Z",
    id: "b24IB70Uti"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 28.79L20 30.79L20 43.29L15 48.29L15 53L16 53L16 48.71L21 43.71L21 31.21L23 29.21L23 20L22 20L22 28.79Z",
    id: "bm9ufXQGt"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 45.79L26 53L27 53L27 46.21L28 45.21L28 33L27 33L27 44.79L26 45.79Z",
    id: "c1gZBKIjGA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 29.79L23 31.79L23 43.79L20 46.79L20 53L21 53L21 47.21L24 44.21L24 32.21L26 30.21L26 16L25 16L25 29.79Z",
    id: "dIqYNTtj"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7BqP60yzA",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a7BqP60yzA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doTCzthfI",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#doTCzthfI",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bdNw2QOrf",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bdNw2QOrf",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1LYKMGFZ",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b1LYKMGFZ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbTVni2tV",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbTVni2tV",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#acbWVzEGK",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#acbWVzEGK",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6qRBI0fj",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a6qRBI0fj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2lHPU0YfD",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a2lHPU0YfD",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1AjHK8GIo",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a1AjHK8GIo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1mvVQgoCA",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1mvVQgoCA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbz8cWJbTQ",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bbz8cWJbTQ",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1abc34VJ2",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d1abc34VJ2",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn2bUpu0d",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bn2bUpu0d",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c35SEsEQo",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c35SEsEQo",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4GoB4kTu",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b4GoB4kTu",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2FHPqG0qW",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#h2FHPqG0qW",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bgjRsj8FF",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bgjRsj8FF",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fm21aig0n",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fm21aig0n",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b24IB70Uti",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b24IB70Uti",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bm9ufXQGt",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bm9ufXQGt",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1gZBKIjGA",
    opacity: 1,
    fill: "#010101",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c1gZBKIjGA",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dIqYNTtj",
    opacity: 1,
    fill: "#00af60",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dIqYNTtj",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMigration);
export default __webpack_public_path__ + "static/media/icon-migration.57663dd1d5e0eb7d6f09fae7fdeef6ec.svg";
export { ForwardRef as ReactComponent };